import * as stylex from '@stylexjs/stylex';
import { faClose } from '@seeqdev/icons/fa-sharp-regular-svg-icons';
import { Icon } from '@seeqdev/qomponents';

interface RemovableTextButtonProps {
  label?: string;
  showFormat?: boolean;
  onClick?: () => void;
}

/**
 * Displays a close 'x' icon on text buttons that indicates that the text button can be removed. An example is in the
 * home screen search results.
 */
export const RemovableTextButton = ({ label, showFormat, onClick }: RemovableTextButtonProps) => {
  return (
    <div>
      {' '}
      {label}
      {showFormat && (
        <Icon icon={faClose} type="text" onClick={onClick} testId="textButtonRemove" xstyle={styles.removeIcon} />
      )}
    </div>
  );
};

const styles = stylex.create({ removeIcon: { marginLeft: '0.625rem' } });
